"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupReceivables = void 0;
/* eslint-disable no-console */
/* eslint-disable camelcase */
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const pushToArrayMap = (map, key, value) => {
    if (!map.has(key)) {
        map.set(key, []);
    }
    map.get(key).push(value);
};
const groupReceivables = async (receivables, progressCallback) => {
    const receivableToLoanAccounts = new Map();
    const loanAccountToReceivables = new Map();
    const receivableIdToReceivable = new Map();
    const loanProductToReceivables = new Map();
    const progressHelper = (0, calc_agent_1.createProgressHelper)({
        progressCallback,
        operation: 'groupReceivables',
        numRows: receivables.length,
    });
    // eslint-disable-next-line no-restricted-syntax, no-plusplus
    for (let index = 0; index < receivables.length; index++) {
        const receivable = receivables[index];
        const { finley_receivable_id, finley_assigned_to_loan_accounts, finley_loan_product_id, } = receivable;
        // eslint-disable-next-line no-await-in-loop
        await progressHelper.updateProgress(index, `Processing ${index}/${receivables.length}`);
        (0, common_1.finleyAssert)(finley_receivable_id, 'finley_receivable_id is empty');
        (0, common_1.finleyAssert)(!receivableIdToReceivable.has(finley_receivable_id), `Duplicate receivable id: [finley_receivable_id:${finley_receivable_id}]`);
        receivableIdToReceivable.set(finley_receivable_id, receivable);
        // loanProduct => receivable
        pushToArrayMap(loanProductToReceivables, finley_loan_product_id, receivable);
        const loanAccounts = finley_assigned_to_loan_accounts === null
            ? [null] // null is special loan account for unassigned receivables
            : finley_assigned_to_loan_accounts.split(';');
        loanAccounts.forEach((loanAccount) => {
            // loanAccount => receivable
            pushToArrayMap(loanAccountToReceivables, loanAccount, finley_receivable_id);
            // receivable => loanAccount
            pushToArrayMap(receivableToLoanAccounts, finley_receivable_id, loanAccount);
        });
    }
    return {
        receivableToLoanAccounts,
        loanAccountToReceivables,
        receivableIdToReceivable,
        loanProductToReceivables,
    };
};
exports.groupReceivables = groupReceivables;
//# sourceMappingURL=groupReceivables.js.map